import React from 'react'

const DueIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="8" fill="#1890FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6786 8.24986C11.6786 10.1434 10.1435 11.6784 8.24998 11.6784C6.35643 11.6784 4.82141 10.1434 4.82141 8.24986C4.82141 6.35631 6.35643 4.82129 8.24998 4.82129C10.1435 4.82129 11.6786 6.35631 11.6786 8.24986ZM8.54999 6.44995C8.54999 6.17381 8.32613 5.94995 8.04999 5.94995C7.77385 5.94995 7.54999 6.17381 7.54999 6.44995V8.44995C7.54999 8.72609 7.77385 8.94995 8.04999 8.94995H10.05C10.3261 8.94995 10.55 8.72609 10.55 8.44995C10.55 8.17381 10.3261 7.94995 10.05 7.94995H8.54999V6.44995Z"
        fill="white"
      />
      <path
        d="M4.25 5.67857L5.67857 4.25"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.75 4.25L12.1786 5.67857"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DueIcon
